"use strict";

exports.__esModule = true;
exports.BarChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Bar = require("./Bar");
var _excluded = ["width", "height", "series", "xScale", "yScale", "barWidth"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var BarChart = exports.BarChart = function BarChart(props) {
  // Non-Grouped Bar chart

  var width = props.width,
    height = props.height,
    series = props.series,
    xScale = props.xScale,
    yScale = props.yScale,
    barWidth = props.barWidth,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var getXValue = series.getXValue,
    getYValue = series.getYValue,
    data = series.data,
    getTooltip = series.getTooltip,
    toolTipPosition = series.toolTipPosition;
  var xPosition = function xPosition(x) {
    return xScale(x);
  };
  var bars = data.map(function (item) {
    var RenderBar = item.render || _Bar.Bar;
    var value = getYValue && getYValue(item) || item.value;
    var key = getXValue && getXValue(item) || item.key || "";
    var bar = /*#__PURE__*/_react["default"].createElement(RenderBar, {
      x: xPosition(key),
      height: height,
      color: item.color,
      yScale: yScale,
      barWidth: barWidth,
      value: value
    });
    if (getTooltip !== undefined) {
      // Blueprint wraps the popover target in a <span> by default. Inside an
      // <svg> that element is never painted, and neither are the bars in it.
      return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
        key: key,
        targetTagName: "g",
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          hide: {
            enabled: false
          }
        },
        position: toolTipPosition || _core.Position.RIGHT,
        usePortal: true,
        interactionKind: _core.PopoverInteractionKind.HOVER,
        content: getTooltip(item)
      }, /*#__PURE__*/_react["default"].createElement("g", {
        key: key,
        "data-key": key,
        className: "bar"
      }, bar));
    } else {
      return /*#__PURE__*/_react["default"].createElement("g", {
        key: key,
        "data-key": key,
        className: "bar"
      }, bar);
    }
  });
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    key: series.metricName,
    className: "BarChart",
    "data-testid": "bar-chart",
    width: width,
    height: height
  }, extra), bars);
};